import * as React from "react";
import Ajax from "../../Ajax";
import swal from 'sweetalert';

interface IFormProps {
  data: object,
  gallery: object
}
interface MyStates {
  ajaxLoaded: boolean,
  spinner: string,
  main_image: string,
  gallery: object,
  file_temp: any
}
export default class WelcomePage extends React.Component<IFormProps, MyStates>{

  constructor(props:IFormProps) {
    super(props);

    this.state = {
      ajaxLoaded: true,
      spinner: 'flex',
      main_image: this.props.data?.['main_image'],
      gallery: this.props.gallery, 
      file_temp: {}
    }
  }

  private handleSubmit(e){
    e.preventDefault();

    var ajax = new Ajax(window.location.origin+ '/reservatio/beallitasok/welcomepage/update');
    ajax.doPost('edit_welcomepage', true).then((response) => {
      if( response.status !== undefined && response.status === 'success' ){
        swal({
          title: "Siker!",
          text: "A köszöntőoldal módosítva!",
          icon: "success",
        });
      } else {
        swal({
          title: "Hiba történt!",
          text: "A köszöntőoldal nem lett módosítva!",
          icon: "error",
        });
      }
    })
  }

  private handleSettingsSubmit(e){
    e.preventDefault();

    var ajax = new Ajax(window.location.origin+ '/reservatio/beallitasok/welcomepage/update');
    ajax.doPost('edit_welcomepage_settings', true).then((response) => {
      if( response.status !== undefined && response.status === 'success' ){
        swal({
          title: "Siker!",
          text: "A köszöntőoldal módosítva!",
          icon: "success",
        });
      } else {
        swal({
          title: "Hiba történt!",
          text: "A köszöntőoldal nem lett módosítva!",
          icon: "error",
        });
      }
    })
  }

  private uploadMainImage(input){
    input.persist()
    this.setState({
      spinner: 'flex',
    }, () => {
      var ajax = new Ajax(  window.location.origin + '/reservatio/beallitasok/welcomepage/uploadMainImage' );
      ajax.doUpload(input).then((response) => {
        input.target.value = ''
        this.setState({ main_image: response.image, spinner: 'none', })
      })
    })
  }

  private uploadGalleryImages(input){
    input.persist()
    this.setState({
      spinner: 'flex',
    }, () => {
      var ajax = new Ajax(  window.location.origin + '/reservatio/beallitasok/welcomepage/uploadGalleryImages/'+this.props.data?.['id'] );
      ajax.doUpload(input).then((response) => {
        input.target.value = ''
        this.setState({ gallery: response, spinner: 'none', })
      })
    })
  }

  private removeGalleryItem(id){
    
    swal({
        title: "Biztos, hogy törli ezt a képet a listáról?",
        icon: "warning",
        buttons: {
            confirm: {
              text: "Igen",
              value: true,
              visible: true,
              className: "float-right btn-success",
              closeModal: true
            },
            cancel: {
              text: "Mégse",
              value: false,
              visible: true,
              className: "float-left btn-danger",
              closeModal: true,
            }
        }
    })
    .then((willDelete) => {
        if (willDelete) {
          this.setState({
            spinner: 'flex'
          }, () => {
            var ajax = new Ajax(window.location.origin + '/reservatio/beallitasok/welcomepage/deleteGalleryItem/'+id);
            ajax.doPost({}).then((response) => {
              this.setState({ gallery: response, spinner: 'none' })
            })
          })
        }
    });
  }

  public render() {
    return (
      <>
      <div className="box">
        <div className="box-header">
          <h3 className="box-title">Köszöntő oldal</h3>   
        </div>
        <div className="box-body" style={{position: 'relative'}}>
          <form id="edit_welcomepage" onSubmit={(e) => this.handleSubmit(e)}>
            <div className="row">
              <div className="col-md-12 form-group">
                <input type="text" name="title" className="form-control" placeholder="Cím" defaultValue={this.props.data?.['title'] ?? ''} required />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 form-group">
                <textarea name="description" className="form-control" placeholder="Köszöntő szöveg" defaultValue={this.props.data?.['description'] ?? ''}></textarea>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 form-group">
                <textarea name="content" id = "description" className="form-control" placeholder="Szabad szöveges mező" defaultValue={this.props.data?.['content'] ?? ''}></textarea>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <button type="submit" className="btn btn-success btn-sm pull-right">Mentés</button>
              </div>
            </div>
          </form>
          <hr />
          <div className="row">
            <div className="col-md-12" key={"mainimage_" + this.state.main_image}>
              <div className="form-group">
                <label>Fő kép</label>
                <input type="file" className="form-control" onChange={(e) => {this.uploadMainImage(e)}} accept="image/png, image/jpeg" />
              </div>
              {
              this.state.main_image != undefined && this.state.main_image != '' && this.state.main_image != null ?
              <div className="form-group">
                <img src={'/' + this.state.main_image} />
              </div>
              :
              <>
              </>
              }
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-12" key={"mainimage_" + this.state.main_image}>
              <div className="form-group">
                <label>Galéria képek</label>
                <input type="file" className="form-control" onChange={(e) => {this.uploadGalleryImages(e)}} accept="image/png, image/jpeg" multiple />
              </div>
            </div>
          </div>
          <div className="row">
            {
            Object.keys(this.state.gallery).length > 0 ?
            <>
            {
              Object.keys(this.state.gallery).map((item) => {
                let img = this.state.gallery[item].image
                return (
                  <div className="col-md-4 " key={"gallery_" + this.state.gallery[item].id}>
                    <div className="gallery_item">
                      <img src={'/' + img} />
                      <button type="button" className="btn btn-danger btn-sm" title="Törlés" onClick={() => this.removeGalleryItem(this.state.gallery[item].id)}>x</button>
                    </div>
                  </div>
                )
              })
            }
            </>
            :
            <>
            </>
            }
          </div>
        </div>
      </div>
      <div className="box">
      <div className="box-header">
        <h3 className="box-title">Egyéb beállítások</h3>   
      </div>
      <div className="box-body" style={{position: 'relative'}}>
        <form id="edit_welcomepage_settings" onSubmit={(e) => this.handleSettingsSubmit(e)}>
          <div className="row">
            <div className="col-md-12 form-group">
            <div className="input-group">
              <span className="input-group-addon">Áfa mértéke:</span>
              <input type="number" name="vat" className="form-control" placeholder="Áfa mértéke" defaultValue={this.props.data?.['vat'] ?? ''} required />
              <span className="input-group-addon bg-white">%</span>
            </div>
            </div>
            <div className = "col-md-12 form-group">
              <div className="input-group">
                <span className="input-group-addon">Lemondás checkbox:</span>
                <textarea name = "booking_rule_term" className = "form-control" placeholder={"Lemondás checkbox"} defaultValue={this.props.data?.['booking_rule_term'] ?? ''} required/>
              </div>
            </div>
          </div>
         
          <div className="row">
            <div className="col-md-12">
              <button type="submit" className="btn btn-success btn-sm pull-right">Mentés</button>
            </div>
          </div>
        </form>
        
      </div>
    </div>
    </>
    )
  }
}